import { render } from "./ContenuFirstPanelItem.vue?vue&type=template&id=47b4030f"
import script from "./ContenuFirstPanelItem.vue?vue&type=script&lang=js"
export * from "./ContenuFirstPanelItem.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__